import { customization } from '@yola/ws-sdk';
import getCompiledFontPairConfig from './get-compiled-font-pair-config';
import prepareNodeElement from './prepare-node-element';
import createMapById from './create-map-by-id';

const applyFontPalette = ({
  fontPairId,
  fontPairConfig = null,
  ignoreCache = false,
  allFonts,
  currentFontPair,
  fontsVariable,
  customFontsTemplate,
}) => {
  const fontsMap = createMapById(allFonts);
  const fontsConfig = fontPairConfig || fontsMap[fontPairId] || currentFontPair;

  if (!fontsConfig) {
    return;
  }

  let configToApply = fontsConfig;

  if (fontsConfig.isCustom) {
    configToApply = getCompiledFontPairConfig(fontsConfig, ignoreCache);
  }

  const { element, compiledElement: fontsElement } = prepareNodeElement({
    elementVariable: fontsVariable,
    customTemplate: customFontsTemplate,
    config: configToApply,
    elementDataAttribute: customization.constants.FONTS_DATA_ATTRIBUTE,
    elementDataParentAttribute: customization.constants.PARENT_FONTS_DATA_ATTRIBUTE,
  });

  if (element) {
    element.parentNode.replaceChild(fontsElement, element);
  }
};

export default applyFontPalette;
